export default __webpack_public_path__ + "svg/calendar/2025/3/mayo.svg?3032319b";